import { useCallback, useState } from 'react';
import {
    VIRTUAL_APPOINTMENT_OVERVIEW_PAGE_SIZE,
    type VirtualAppointmentOverviewQuery
} from '../../../services/virtualAppointmentsOverview';
import type { OverviewPaging } from './VirtualAppointmentsOverviewTable';
import { useSessionTableMode } from '../../../hooks/useSessionTableMode';

const TABLE_MODE_STORAGE_KEY = 'odo:va-overview:table-mode';

// The page belongs to one query and mode: any change to either starts again from page 1.
export function useOverviewPaging(query: VirtualAppointmentOverviewQuery): OverviewPaging {
    const [mode, onModeChange] = useSessionTableMode(TABLE_MODE_STORAGE_KEY);
    const scope = `${mode}|${JSON.stringify(query)}`;
    const [paging, setPaging] = useState({ scope, page: 1 });
    const page = paging.scope === scope ? paging.page : 1;
    const onPage = useCallback((next: number) => setPaging({ scope, page: next }), [scope]);
    return {
        mode,
        onModeChange,
        page,
        pageSize: VIRTUAL_APPOINTMENT_OVERVIEW_PAGE_SIZE,
        onPage,
        resetKey: `${scope}|${page}`
    };
}
